import { ProductTranslation } from '../../../../../api/Argentia/model/contracts'
import { ProductTranslationModel, ProductTranslationTableModel } from './translationsCard.model'

export const translationsToTranslationTableModelMapper = (
  translations: ProductTranslationModel[]
): ProductTranslationTableModel[] => {
  return translations.map(translation => translationToTranslationTableModelMapper(translation))
}

export const translationToTranslationTableModelMapper = (
  translation: ProductTranslationModel
): ProductTranslationTableModel => {
  return {
    id: translation.id!,
    productId: translation.productId!,
    language: translation.language,
    description: translation.description,
    default: translation.default,
    notDefault: !translation.default,
    tempId: translation.tempId,
    actions: translation.actions
  }
}

export const translationsTableModelMapperToTranslationsModel = (
  tableTranslations: ProductTranslationTableModel[]
): ProductTranslationModel[] => {
  return tableTranslations.map(translation => translationToTranslationTableModelMapper(translation))
}

export const translationTableModelMapperToTranslationsModel = (
  tableTranslation: ProductTranslationTableModel
): ProductTranslationModel => {
  return {
    id: tableTranslation.id,
    productId: tableTranslation.productId,
    language: tableTranslation.language,
    description: tableTranslation.description,
    default: tableTranslation.default,
    tempId: tableTranslation.tempId,
    actions: tableTranslation.actions
  }
}

export const mapTranslationsToTranslationsModel = (
  translations: ProductTranslation[] | undefined
): ProductTranslationModel[] => {
  if (translations && translations.length > 0) {
    return translations.map(
      o =>
        ({
          id: o.id,
          productId: o.productId,
          language: o.language,
          description: o.description,
          default: o.default,
          tempId: o.tempId,
          actions: o.actions
        }) as ProductTranslationModel
    )
  } else {
    return []
  }
}
